import { useState } from "react";

export function LangToggle() {
  const [lang, setLang] = useState<"RU" | "EN">("RU");
  return (
    <div className="hidden items-center gap-1 text-[11px] font-medium text-[var(--color-fg-muted)] sm:flex">
      <button
        onClick={() => setLang("RU")}
        className={"rounded-md px-2 py-1 transition-colors " + (lang === "RU" ? "text-[var(--color-fg)]" : "hover:text-[var(--color-fg)]")}
      >
        RU
      </button>
      <span className="text-[var(--color-fg-faint)]">/</span>
      <button
        onClick={() => setLang("EN")}
        className={"rounded-md px-2 py-1 transition-colors " + (lang === "EN" ? "text-[var(--color-fg)]" : "hover:text-[var(--color-fg)]")}
      >
        EN
      </button>
    </div>
  );
}
